import gql from "graphql-tag";
const runAveragesMutation = gql(`
mutation ($params: runAveragesInput!) {
  runAverages(params: $params) {
  group
  }
}
`)
export default runAveragesMutation;
